import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-parcel-activation-banner',
  template: require('./parcel-activation-banner.component.html'),
  styles: [`
    .parcel-activation-banner {
      background-color: #fff4ce;
      border: 1px solid #f1d176;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 16px;
      color: #222;
      display: flex;
      align-items: flex-start;
      gap: 8px;
    }
    .parcel-activation-banner-icon {
      color: #2e7d32;
      font-size: 20px;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      margin-top: 2px;
    }
    .parcel-activation-banner-lines {
      flex: 1;
      min-width: 0;
    }
    .parcel-activation-banner-line {
      font-size: 14px;
      line-height: 1.5;
    }
    .parcel-activation-banner-line + .parcel-activation-banner-line {
      margin-top: 4px;
    }
    .parcel-activation-banner-line-head {
      font-weight: 700;
      letter-spacing: 0.2px;
    }
  `]
})
export class ParcelActivationBannerComponent {
  @Input() header = '';
  @Input() line1 = '';
  @Input() line2 = '';
}
